module.exports = __webpack_public_path__ + "img/cod_charge_logo.053d1855.png";